/**
 * Logo MiniCRM: icona dell'app (public/icon.svg) + wordmark opzionale.
 * Usato nelle schermate di autenticazione e, in generale, dove serve
 * il marchio fuori dalla sidebar.
 */
export default function Logo({
  withWordmark = true,
  imgClassName = 'h-16 w-16 sm:h-20 sm:w-20',
  className = '',
}) {
  return (
    <div className={`flex flex-col items-center gap-3 select-none ${className}`}>
      <img
        src="/icon.svg"
        alt="Logo MiniCRM"
        width={80}
        height={80}
        className={`rounded-2xl shadow-lg shadow-brand-600/30 ${imgClassName}`}
      />
      {withWordmark && (
        <p className="text-xl font-semibold tracking-tight text-brand-300">MiniCRM</p>
      )}
    </div>
  );
}
